import React from 'react';
import PropTypes from 'prop-types';
import { FaTwitter, FaInstagram } from 'react-icons/fa';
import { IoLogoTiktok } from 'react-icons/io5';
import './ProfileInfo.css';

const ProfileInfo = ({ name, username, bio, twitter, instagram, tiktok }) => {
  return (
    <div className="info">
      <div className="flex flex-ai-c mb">
        <h4>{name}</h4>
        <p className="username">{username}</p>
      </div>
      <div className="mb-1">
        <p className="mb title">Bio</p>
        <p className="desc">{bio}</p>
      </div>
      <div className="info__socials">
        <div className="flex flex-ai-c mb">
          <FaTwitter className="icon icon--xs" color="#019cb1" />
          <p>{twitter}</p>
        </div>
        <div className="flex flex-ai-c mb">
          <FaInstagram className="icon icon--xs" color="#019cb1" />
          <p>{instagram}</p>
        </div>
        <div className="flex flex-ai-c mb">
          <IoLogoTiktok className="icon icon--xs" color="#019cb1" />
          <p>{tiktok}</p>
        </div>
      </div>
    </div>
  );
};

ProfileInfo.propTypes = {
  name: PropTypes.string,
  username: PropTypes.string,
  bio: PropTypes.string,
  twitter: PropTypes.string,
  instagram: PropTypes.string,
  tiktok: PropTypes.string,
};

ProfileInfo.defaultProps = {
  name: 'Tolulope Victoria',
  username: '#simplytolz',
  bio: 'A senior product designer at Haelo| Former product designer at @worldcitizen',
  twitter: '@simplytolz',
  instagram: '@simplytolz',
  tiktok: '@simplytolz',
};

export default ProfileInfo;
